module.exports = "/_next/static/resources/photo-ariel-7c23ec8a826af118dc9ca2a602f5766b.webp";